import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MarcaService } from '../../../core/services/marca.service';
import { MarcaLogo } from '../../../shared/components/marca-logo/marca-logo';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, MarcaLogo],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  readonly marca = inject(MarcaService);
  year = new Date().getFullYear();

  abrirTicket(): void {
    window.open('/soporte', '_blank');
  }
}
